import { type ReactNode } from 'react'
import { useMediaQuery } from '#app/hooks/use-media-query.tsx'

export const WizardFormContainer: React.FC<{
	children: ReactNode
	isPage: boolean
}> = ({ children }) => {
	const isDesktop = useMediaQuery('(min-width: 768px)')

	if (isDesktop) {
		return <div className="W-full flex h-full flex-col">{children}</div>
	}

	if (isDesktop === false)
		return <div className="flex h-full flex-col">{children}</div>
}
